import { $, $$ } from '../helpers/selectors';

const SELECTOR = '.js-video';
const playBtnClass = '.play-button';
const videoClass = '.video';
const overlayClass = '.video__overlay';
const contentClass = '.video__content';
const videos = $$(SELECTOR);

class Video {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    function handleDatalayerPush(videoEventType, videoTitle, videoType) {
      const userId = window.dataLayer_content.UserOktaId || '';

      window.dataLayer.push({
        event: 'videoEvent',
        eventType: videoEventType,
        videoTitle,
        videoType,
        userId,
      });
    }

    function handleVideoGTM(videoElem) {
      let percentage = 0;
      const parentElem = videoElem.closest('.js-video');
      const videoTitle = videoElem.getAttribute('title') ? videoElem.getAttribute('title') : '';
      let videoType = '';

      if (parentElem.classList.contains('screener-video')) {
        if (parentElem.classList.contains('screener-video--inline')) {
          videoType = 'screener - inline';
        } else {
          videoType = 'screener - fullwidth';
        }
      } else if (parentElem.classList.contains('inline-video')) {
        videoType = 'inline';
      } else {
        videoType = 'fullwidth';
      }

      function videoProgress() {
        const currPercentage = Math.round((videoElem.currentTime / videoElem.duration) * 100);
        if (currPercentage !== percentage) {
          percentage = currPercentage;
          if (percentage === 25) {
            handleDatalayerPush('video 25% quartile', videoTitle, videoType);
          } else if (percentage === 50) {
            handleDatalayerPush('video 50% quartile', videoTitle, videoType);
          } else if (percentage === 75) {
            handleDatalayerPush('video 75% quartile', videoTitle, videoType);
          } else if (percentage === 100) {
            handleDatalayerPush('video completes', videoTitle, videoType);
          }
        }
      }
      videoElem.addEventListener('timeupdate', videoProgress);
    }

    function handleFullscreen(e) {
      const elem = e.target;
      elem.focus();
    }

    function handleVideoInit() {
      videos.forEach(video => {
        const videoPlayBtn = $(playBtnClass, video);
        const videoElem = $(videoClass, video);

        videoPlayBtn.addEventListener('click', () => videoElem.play());
        videoElem.addEventListener('pause', handleVideoPaused);
        videoElem.addEventListener('play', handleVideoPlay);
        videoElem.addEventListener('ended', handleVideoEnded);
        handleVideoGTM(videoElem);

        if (window.innerWidth >= 1024) {
          //For IOS and safari devices
          videoElem.addEventListener('webkitbeginfullscreen', handleFullscreen);
          videoElem.addEventListener('webkitendfullscreen', handleFullscreen);

          //For desktop screens
          ['', 'webkit', 'moz', 'ms'].forEach(
            prefix => videoElem.addEventListener(prefix + 'fullscreenchange', handleFullscreen, false)
          );
        }
      });
    }

    function handleVideoPlay(e) {
      handleStopAllVideoPlaying(e.target);
      const parentElem = e.target.closest(SELECTOR);
      const videoPlayBtn = $(playBtnClass, parentElem);
      const videoElem = $(videoClass, parentElem);
      const videoOverlay = $(overlayClass, parentElem);
      const contentElem = $(contentClass, parentElem);
      const videoTitle = videoElem.getAttribute('title') ? videoElem.getAttribute('title') : '';
      let videoType = '';
      let checkButtonFocus = null;

      if (parentElem.classList.contains('screener-video')) {
        if (parentElem.classList.contains('screener-video--inline')) {
          videoType = 'screener - inline';
        } else {
          videoType = 'screener - fullwidth';
        }
      } else if (parentElem.classList.contains('inline-video')) {
        videoType = 'inline';
      } else {
        videoType = 'fullwidth';
      }

      handleDatalayerPush('video play', videoTitle, videoType);

      checkButtonFocus = setInterval(() => {
        if (! document.activeElement !== videoPlayBtn) {
          videoPlayBtn.setAttribute('aria-hidden', 'true');
          if (window.innerWidth <= 767) {
            videoPlayBtn.style.display = 'none';
          }
          clearInterval(checkButtonFocus);
        }
      }, 100);

      videoElem.setAttribute('tabindex', '0');
      videoElem.removeAttribute('aria-hidden');
      videoOverlay.classList.add('is-hidden');
      videoElem.classList.add('is-playing');
      videoElem.setAttribute('controls', 'true');

      if (contentElem) {
        contentElem.classList.add('is-hidden');
      }
    }

    function handleVideoPaused(e) {
      const parentElem = e.target.closest(SELECTOR);
      const videoElem = $(videoClass, parentElem);
      const currPercentage = Math.round((videoElem.currentTime / videoElem.duration) * 100);
      const videoTitle = videoElem.getAttribute('title') ? videoElem.getAttribute('title') : '';
      let videoType = '';

      // TODO: This Should be abstracted into a single function to avoid duplication.
      if (parentElem.classList.contains('screener-video')) {
        if (parentElem.classList.contains('screener-video--inline')) {
          videoType = 'screener - inline';
        } else {
          videoType = 'screener - fullwidth';
        }
      } else if (parentElem.classList.contains('inline-video')) {
        videoType = 'inline';
      } else {
        videoType = 'fullwidth';
      }

      if (currPercentage !== 100) {
        handleDatalayerPush('video pause', videoTitle, videoType);
      }

      videoElem.classList.remove('is-playing');
    }

    function handleStopAllVideoPlaying(target) {
      videos.forEach(item => {
        const videoElem = $(videoClass, item);
        if (! videoElem.paused && videoElem !== target) {
          videoElem.pause();
        }
      });
    }

    function handleVideoEnded(e) {
      const parentElem = e.target.closest(SELECTOR);
      const videoPlayBtn = $(playBtnClass, parentElem);
      const videoElem = $(videoClass, parentElem);
      const videoOverlay = $(overlayClass, parentElem);
      const contentElem = $(contentClass, parentElem);

      videoPlayBtn.removeAttribute('aria-hidden');
      videoPlayBtn.style.display = '';
      videoOverlay.classList.remove('is-hidden');
      if (contentElem) {
        contentElem.classList.remove('is-hidden');
      }
      videoElem.setAttribute('aria-hidden', 'true');
      videoElem.setAttribute('tabindex', '-1');
      videoPlayBtn.focus();
    }

    handleVideoInit();
  }
}

export default Video;
